import { useState, useEffect } from 'react';

export interface IntegrationSettings {
  projectCodeMaxLength: number;
  projectNameMaxLength: number;
  descriptionMaxLength: number;
}

const DEFAULT_SETTINGS: IntegrationSettings = {
  projectCodeMaxLength: 10,
  projectNameMaxLength: 80,
  descriptionMaxLength: 80,
};

export const useIntegrationSettings = () => {
  const [settings, setSettings] = useState<IntegrationSettings>(DEFAULT_SETTINGS);

  useEffect(() => {
    const loadSettings = () => {
      try {
        const stored = localStorage.getItem('integration-settings');
        if (stored) {
          const parsed = JSON.parse(stored);
          setSettings(parsed);
        }
      } catch (error) {
        console.error('Failed to load integration settings:', error);
      }
    };

    loadSettings();

    // Listen for storage changes (in case settings are updated in another tab or component)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'integration-settings' && e.newValue) {
        try {
          const parsed = JSON.parse(e.newValue);
          setSettings(parsed);
        } catch (error) {
          console.error('Failed to parse integration settings:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return settings;
};
